import React from 'react'
import { Segment, Dropdown, Loader, Button, Divider, Table, Grid, Input, Label, Confirm } from 'semantic-ui-react'
import { Redirect, NavLink } from 'react-router-dom'

import isEmpty from 'lodash/isEmpty'
import find from 'lodash/find'
import titleCase from 'title-case'

import ToDoModal from './ToDoModal'
import CreatedModal from './CreatedModal'
import CheckedModal from './CheckedModal'
import ReviewedModal from './ReviewedModal'
import ApprovedModal from './ApprovedModal'
import PaginationTable from '../../components/PaginationTable/PaginationTable'

import './Home.css'
import constants from '../../constants';

const _ = {
  isEmpty: isEmpty,
  find: find
}

const changeCase = {
  titleCase: titleCase
}

const HomePV = (props) => {
  if (props.auth) {
    const { activePage, itemPerPage, searchKey, details, detailsAdmin, quarter } = props;
    if (props.userType === 'staff' || props.userType === 'cashier') {
      return <Redirect to='/applicants' />
    }
    let optionsSchoolYears;
    if (props.schoolYears) {
      optionsSchoolYears = props.schoolYears.map((schoolYear,index) => {
        return (
            { key: schoolYear.schoolYearId, value: schoolYear.schoolYearId, text: schoolYear.name }
        )
      })
    }
    const optionsQuarters = constants.quarter;
    let body;
    if (!_.isEmpty(props.perSubjectSummary) && props.activeButton === 'subject' && !_.isEmpty(props.perSubjectSummaryConducts)) {
      body = (
        <div>
          <h3>SUBJECTS</h3>

          <ToDoModal
            title='My Subjects'
            quarter={quarter}
            isGrades={true}
            value={props.perSubjectSummary.summary.toDo.count}
            data={props.perSubjectSummary.summary.toDo.data}
            sectionSubjects={props.perSubjectSummary.sectionSubjects}
            handleNotify={props.handleNotify}
            openConfirm={props.openConfirm}
            openConfirmation={props.openConfirmation}
            closeConfirmation={props.closeConfirmation}
          />

          <CreatedModal
            title='My Subjects'
            quarter={quarter}
            isGrades={true}
            value={props.perSubjectSummary.summary.created.count}
            data={props.perSubjectSummary.summary.created.data}
            sectionSubjects={props.perSubjectSummary.sectionSubjects}
          />

          <CheckedModal
            title='My Subjects'
            quarter={quarter}
            isGrades={true}
            value={props.perSubjectSummary.summary.checked.count}
            data={props.perSubjectSummary.summary.checked.data}
            sectionSubjects={props.perSubjectSummary.sectionSubjects}
          />

          <ReviewedModal
            title='My Subjects'
            quarter={quarter}
            isGrades={true}
            value={props.perSubjectSummary.summary.reviewed.count}
            data={props.perSubjectSummary.summary.reviewed.data}
            sectionSubjects={props.perSubjectSummary.sectionSubjects}
          />

          <ApprovedModal
            title='My Subjects'
            quarter={quarter}
            isGrades={true}
            value={props.perSubjectSummary.summary.approved.count}
            data={props.perSubjectSummary.summary.approved.data}
            sectionSubjects={props.perSubjectSummary.sectionSubjects}
          />

          <h3>CONDUCTS</h3>
            <ToDoModal
              title='My Subjects'
              quarter={quarter}
              isGrades={false}
              value={props.perSubjectSummaryConducts.summary.toDo.count}
              data={props.perSubjectSummaryConducts.summary.toDo.data}
              sectionSubjects={props.perSubjectSummaryConducts.sectionSubjects}
              handleNotify={props.handleNotify}
              openConfirm={props.openConfirm}
              openConfirmation={props.openConfirmation}
              closeConfirmation={props.closeConfirmation}
            />

            <CreatedModal
              title='My Subjects'
              quarter={quarter}
              isGrades={false}
              value={props.perSubjectSummaryConducts.summary.created.count}
              data={props.perSubjectSummaryConducts.summary.created.data}
              sectionSubjects={props.perSubjectSummaryConducts.sectionSubjects}
            />

            <CheckedModal
              title='My Subjects'
              quarter={quarter}
              isGrades={false}
              value={props.perSubjectSummaryConducts.summary.checked.count}
              data={props.perSubjectSummaryConducts.summary.checked.data}
              sectionSubjects={props.perSubjectSummaryConducts.sectionSubjects}
            />

            <ReviewedModal
              title='My Subjects'
              quarter={quarter}
              isGrades={false}
              value={props.perSubjectSummaryConducts.summary.reviewed.count}
              data={props.perSubjectSummaryConducts.summary.reviewed.data}
              sectionSubjects={props.perSubjectSummaryConducts.sectionSubjects}
            />

            <ApprovedModal
              title='My Subjects'
              quarter={quarter}
              isGrades={false}
              value={props.perSubjectSummaryConducts.summary.approved.count}
              data={props.perSubjectSummaryConducts.summary.approved.data}
              sectionSubjects={props.perSubjectSummaryConducts.sectionSubjects}
            />
        </div>
      )
    } else if (!_.isEmpty(props.perSectionSummary) && props.activeButton === 'section' && !_.isEmpty(props.perSectionSummaryConducts)) {
      const headers = (
        <Table.Row>
          <Table.HeaderCell textAlign='center'>
            Section
          </Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>
            Details Type
          </Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>
            Status
          </Table.HeaderCell>
        </Table.Row>
      )

      const tableBody = props.perSectionSummary.sections.map((section, key )=> {
        if(_.isEmpty(props.perSectionSummary.sections) ) return null;
          const tableRow = section.details.map((detail, i )=> {
            if(detail.quarter === props.quarter) {
              return (
                <Table.Row key={i} className='sections-table-row'>
                  <Table.Cell textAlign='center'>
                    <NavLink to={`/classes/${section.sectionId}`}>
                      {section.gradeLevel} - {section.name}
                    </NavLink>
                  </Table.Cell>
                  <Table.Cell textAlign='center'>{changeCase.titleCase(detail.type)}</Table.Cell>
                  <Table.Cell textAlign='center'>
                    {
                      detail.type === 'attendance' ?
                      <NavLink to={`/attendances/${props.schoolYearId}/${section.sectionId}?quarter=${props.quarter}`}>
                        {detail.status}
                      </NavLink> :
                      detail.type === 'remark' ?
                      <NavLink to={`/remarks/${section.sectionId}?quarter=${props.quarter}`}>
                        {detail.status}
                      </NavLink>
                      :
                      <NavLink to={`/classconducts/${section.sectionId}?quarter=${props.quarter}`}>
                        {detail.status}
                      </NavLink>
                    }
                  </Table.Cell>
                </Table.Row>
              );
            } else {
              return null;
            }
          })
          return tableRow;
      });

      body = (
        <div>
          <h3>HANDLED SECTION</h3>
          <Grid centered columns={3}>
            <Grid.Column>
              {
                props.perSectionSummary.sections.length > 0 ?
                <Table celled striped size='small'>
                  <Table.Header>
                    {headers}
                  </Table.Header>
                  <Table.Body>{tableBody}</Table.Body>
                </Table> :
                <h3>No sections available.</h3>
              }
            </Grid.Column>
          </Grid>

          <h3>SUBJECTS</h3>

          <ToDoModal
            title='My Class'
            quarter={quarter}
            isGrades={true}
            value={props.perSectionSummary.summary.toDo.count}
            data={props.perSectionSummary.summary.toDo.data}
            sectionSubjects={props.perSectionSummary.sectionSubjects}
            handleNotify={props.handleNotify}
            openConfirm={props.openConfirm}
            openConfirmation={props.openConfirmation}
            closeConfirmation={props.closeConfirmation}
          />

          <CreatedModal
            title='My Class'
            quarter={quarter}
            isGrades={true}
            value={props.perSectionSummary.summary.created.count}
            data={props.perSectionSummary.summary.created.data}
            sectionSubjects={props.perSectionSummary.sectionSubjects}
          />

          <CheckedModal
            title='My Class'
            quarter={quarter}
            isGrades={true}
            value={props.perSectionSummary.summary.checked.count}
            data={props.perSectionSummary.summary.checked.data}
            sectionSubjects={props.perSectionSummary.sectionSubjects}
          />

          <ReviewedModal
            title='My Class'
            quarter={quarter}
            isGrades={true}
            value={props.perSectionSummary.summary.reviewed.count}
            data={props.perSectionSummary.summary.reviewed.data}
            sectionSubjects={props.perSectionSummary.sectionSubjects}
          />

          <ApprovedModal
            title='My Class'
            quarter={quarter}
            isGrades={true}
            value={props.perSectionSummary.summary.approved.count}
            data={props.perSectionSummary.summary.approved.data}
            sectionSubjects={props.perSectionSummary.sectionSubjects}
          />

          <h3>CONDUCTS</h3>
            <ToDoModal
              title='My Class'
              quarter={quarter}
              isGrades={false}
              value={props.perSectionSummaryConducts.summary.toDo.count}
              data={props.perSectionSummaryConducts.summary.toDo.data}
              sectionSubjects={props.perSectionSummaryConducts.sectionSubjects}
              handleNotify={props.handleNotify}
              openConfirm={props.openConfirm}
              openConfirmation={props.openConfirmation}
              closeConfirmation={props.closeConfirmation}
            />

            <CreatedModal
              title='My Class'
              quarter={quarter}
              value={props.perSectionSummaryConducts.summary.created.count}
              data={props.perSectionSummaryConducts.summary.created.data}
              sectionSubjects={props.perSectionSummaryConducts.sectionSubjects}
            />

            <CheckedModal
              title='My Class'
              quarter={quarter}
              isGrades={false}
              value={props.perSectionSummaryConducts.summary.checked.count}
              data={props.perSectionSummaryConducts.summary.checked.data}
              sectionSubjects={props.perSectionSummaryConducts.sectionSubjects}
            />

            <ReviewedModal
              title='My Class'
              quarter={quarter}
              isGrades={false}
              value={props.perSectionSummaryConducts.summary.reviewed.count}
              data={props.perSectionSummaryConducts.summary.reviewed.data}
              sectionSubjects={props.perSectionSummaryConducts.sectionSubjects}
            />

            <ApprovedModal
              title='My Class'
              quarter={quarter}
              isGrades={false}
              value={props.perSectionSummaryConducts.summary.approved.count}
              data={props.perSectionSummaryConducts.summary.approved.data}
              sectionSubjects={props.perSectionSummaryConducts.sectionSubjects}
            />

        </div>
      )
    } else if (!_.isEmpty(props.perLevelSummary) && props.activeButton === 'level' && !_.isEmpty(props.perLevelSummaryConducts)) {
      let level;
      if (props.levelType === 'SHS') {
        level = 'Senior High School Level';
      } else if (props.levelType === 'JHS') {
        level = 'Junior High School Level';
      } else if (props.levelType === 'ELEMP') {
        level = 'Elementary - Primary Level';
      } else if (props.levelType === 'ELEMI') {
        level = 'Elementary - Intermediate Level';
      } else if(props.levelType === 'HS'){
        level = 'High School Level'
      } else if(props.levelType === 'ELEM'){
        level = 'Elementary Level'
      } else {
        level = 'You are not a level head. Notify the administrator if you are seeing this without proper permission.'
      }

      const headers = (
        <Table.Row>
          <Table.HeaderCell textAlign='center'>
            Section
          </Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>
            Details Type
          </Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>
            Status
          </Table.HeaderCell>
        </Table.Row>
      )

      let currentData = details.filter(props.isSearched(searchKey));
      const indexOfLast = activePage * itemPerPage;
      const indexOfFirst = indexOfLast - itemPerPage;
      const rowLength = currentData.length;
      currentData = currentData.slice(indexOfFirst, indexOfLast);
      const totalPages = Math.ceil(rowLength / itemPerPage);

      const tableBody = currentData.map((detail, key )=> {
        return (
          <Table.Row key={key} className='sections-table-row'>
            <Table.Cell textAlign='center'>
              <NavLink to={`/classes/${detail.section.sectionId}`}>
                {detail.section.gradeLevel} - {detail.section.name}
              </NavLink>
            </Table.Cell>
            <Table.Cell textAlign='center'>{changeCase.titleCase(detail.type)}</Table.Cell>
            {
              detail.status === 'To Do' ?
              <Table.Cell textAlign='center'>
                {
                  detail.type === 'attendance' ?
                  <Label as='a' content='Notify' icon='bell' color='red' onClick={
                      () => {props.openConfirmation(`/attendances/${props.schoolYearId}/${detail.section.sectionId}?quarter=${props.quarter}`,detail.section.teacherId)}
                  }/> :
                  detail.type === 'remark' ?
                  <Label as='a' content='Notify' icon='bell' color='red' onClick={
                      () => {props.openConfirmation(`/remarks/${props.schoolYearId}/${detail.section.sectionId}?quarter=${props.quarter}`,detail.section.teacherId)}
                  }/>
                  :
                  <Label as='a' content='Notify' icon='bell' color='red' onClick={
                      () => {props.openConfirmation(`/classconducts/${detail.section.sectionId}?quarter=${props.quarter}`,detail.section.teacherId)}
                  }/>
                }
              </Table.Cell>
              : <Table.Cell textAlign='center'>
              {
                detail.type === 'attendance' ?
                <NavLink to={`/attendances/${props.schoolYearId}/${detail.section.sectionId}?quarter=${props.quarter}`}>
                  {detail.status}
                </NavLink> :
                detail.type === 'remark' ?
                <NavLink to={`/remarks/${detail.section.sectionId}?quarter=${props.quarter}`}>
                  {detail.status}
                </NavLink>
                :
                <NavLink to={`/classconducts/${detail.section.sectionId}?quarter=${props.quarter}`}>
                  {detail.status}
                </NavLink>
              }
              </Table.Cell>
            }
          </Table.Row>
        );
      });

      body = (
        <div>
          <h3> {level} </h3>

          <h3>HANDLED SECTIONS</h3>
          <Grid centered columns={2}>
            <Grid.Column>
              <Input
                fluid
                icon='search'
                value={searchKey}
                onChange={props.onSearchChange}
                placeholder='Search Sections'
              />
              {
                details.length > 0 ?
                <Table celled striped size='small' compact>
                  <Table.Header>
                    {headers}
                  </Table.Header>
                  <Table.Body>{tableBody}</Table.Body>
                  {
                    details.length > itemPerPage ?
                    <PaginationTable
                      onPageChange={props.handlePaginationChange}
                      totalPages={totalPages}
                      activePage={activePage}
                      fields={['Section', 'Type', 'Status']}
                    >

                    </PaginationTable>
                    :
                    null
                  }
                </Table> :
                null
              }
            </Grid.Column>
          </Grid>
          <h3>SUBJECTS</h3>

          <ToDoModal
            title='Level Summary'
            quarter={quarter}
            isGrades={true}
            value={props.perLevelSummary.summary.toDo.count}
            data={props.perLevelSummary.summary.toDo.data}
            sectionSubjects={props.perLevelSummary.sectionSubjects}
            handleNotify={props.handleNotify}
            openConfirm={props.openConfirm}
            openConfirmation={props.openConfirmation}
            closeConfirmation={props.closeConfirmation}
          />

          <CreatedModal
            title='Level Summary'
            quarter={quarter}
            isGrades={true}
            value={props.perLevelSummary.summary.created.count}
            data={props.perLevelSummary.summary.created.data}
            sectionSubjects={props.perLevelSummary.sectionSubjects}
          />

          <CheckedModal
            title='Level Summary'
            quarter={quarter}
            isGrades={true}
            value={props.perLevelSummary.summary.checked.count}
            data={props.perLevelSummary.summary.checked.data}
            sectionSubjects={props.perLevelSummary.sectionSubjects}
          />

          <ReviewedModal
            title='Level Summary'
            quarter={quarter}
            isGrades={true}
            value={props.perLevelSummary.summary.reviewed.count}
            data={props.perLevelSummary.summary.reviewed.data}
            sectionSubjects={props.perLevelSummary.sectionSubjects}
          />

          <ApprovedModal
            title='Level Summary'
            quarter={quarter}
            isGrades={true}
            value={props.perLevelSummary.summary.approved.count}
            data={props.perLevelSummary.summary.approved.data}
            sectionSubjects={props.perLevelSummary.sectionSubjects}
          />

          <h3>CONDUCTS</h3>
            <ToDoModal
              title='Level Summary'
              quarter={quarter}
              isGrades={false}
              value={props.perLevelSummaryConducts.summary.toDo.count}
              data={props.perLevelSummaryConducts.summary.toDo.data}
              sectionSubjects={props.perLevelSummaryConducts.sectionSubjects}
              handleNotify={props.handleNotify}
              openConfirm={props.openConfirm}
              openConfirmation={props.openConfirmation}
              closeConfirmation={props.closeConfirmation}
            />

            <CreatedModal
              title='Level Summary'
              quarter={quarter}
              isGrades={false}
              value={props.perLevelSummaryConducts.summary.created.count}
              data={props.perLevelSummaryConducts.summary.created.data}
              sectionSubjects={props.perLevelSummaryConducts.sectionSubjects}
            />

            <CheckedModal
              title='Level Summary'
              quarter={quarter}
              isGrades={false}
              value={props.perLevelSummaryConducts.summary.checked.count}
              data={props.perLevelSummaryConducts.summary.checked.data}
              sectionSubjects={props.perLevelSummaryConducts.sectionSubjects}
            />

            <ReviewedModal
              title='Level Summary'
              quarter={quarter}
              isGrades={false}
              value={props.perLevelSummaryConducts.summary.reviewed.count}
              data={props.perLevelSummaryConducts.summary.reviewed.data}
              sectionSubjects={props.perLevelSummaryConducts.sectionSubjects}
            />

            <ApprovedModal
              title='Level Summary'
              quarter={quarter}
              isGrades={false}
              value={props.perLevelSummaryConducts.summary.approved.count}
              data={props.perLevelSummaryConducts.summary.approved.data}
              sectionSubjects={props.perLevelSummaryConducts.sectionSubjects}
            />
        </div>
      )
    } else if (!_.isEmpty(props.perQuarterSummary) && props.activeButton === 'all' && !_.isEmpty(props.perQuarterSummaryConducts)) {
      const quarterLabel = _.find(optionsQuarters, {
        value: props.quarter
      });

      const headers = (
        <Table.Row>
          <Table.HeaderCell textAlign='center'>
            Section
          </Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>
            Details Type
          </Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>
            Status
          </Table.HeaderCell>
        </Table.Row>
      )

      let currentData = detailsAdmin.filter(props.isSearched(searchKey));
      const indexOfLast = activePage * itemPerPage;
      const indexOfFirst = indexOfLast - itemPerPage;
      const rowLength = currentData.length;
      currentData = currentData.slice(indexOfFirst, indexOfLast);
      const totalPages = Math.ceil(rowLength / itemPerPage);

      const tableBody = currentData.map((detail, key )=> {
        return (
          <Table.Row key={key} className='sections-table-row'>
            <Table.Cell textAlign='center'>
              <NavLink to={`/classes/${detail.section.sectionId}`}>
                {detail.section.gradeLevel} - {detail.section.name}
              </NavLink>
            </Table.Cell>
            <Table.Cell textAlign='center'>{changeCase.titleCase(detail.type)}</Table.Cell>
            {
              detail.status === 'To Do' ?
              <Table.Cell textAlign='center'>
                {
                  detail.type === 'attendance' ?
                  <Label as='a' content='Notify' icon='bell' color='red' onClick={
                      () => {props.openConfirmation(`/attendances/${props.schoolYearId}/${detail.section.sectionId}?quarter=${props.quarter}`,detail.section.teacherId)}
                  }/> :
                  detail.type === 'remark' ?
                  <Label as='a' content='Notify' icon='bell' color='red' onClick={
                      () => {props.openConfirmation(`/remarks/${detail.section.sectionId}?quarter=${props.quarter}`,detail.section.teacherId)}
                  }/>
                  :
                  <Label as='a' content='Notify' icon='bell' color='red' onClick={
                      () => {props.openConfirmation(`/classconducts/${detail.section.sectionId}?quarter=${props.quarter}`,detail.section.teacherId)}
                  }/>
                }
              </Table.Cell>
              : <Table.Cell textAlign='center'>
              {
                detail.type === 'attendance' ?
                <NavLink to={`/attendances/${props.schoolYearId}/${detail.section.sectionId}?quarter=${props.quarter}`}>
                  {detail.status}
                </NavLink> :
                detail.type === 'remark' ?
                <NavLink to={`/remarks/${detail.section.sectionId}?quarter=${props.quarter}`}>
                  {detail.status}
                </NavLink>
                :
                <NavLink to={`/classconducts/${detail.section.sectionId}?quarter=${props.quarter}`}>
                  {detail.status}
                </NavLink>
              }
              </Table.Cell>
            }
          </Table.Row>
        );
      });

      body = (
        <div>
          <h3> {quarterLabel.text} </h3>
            <h3>HANDLED SECTIONS</h3>
            <Grid centered columns={2}>
              <Grid.Column>
                <Input
                  fluid
                  icon='search'
                  value={searchKey}
                  onChange={props.onSearchChange}
                  placeholder='Search Sections'
                />
                {
                  detailsAdmin.length > 0 ?
                  <Table celled striped size='small' compact>
                    <Table.Header>
                      {headers}
                    </Table.Header>
                    <Table.Body>{tableBody}</Table.Body>
                    {
                      detailsAdmin.length > itemPerPage ?
                      <PaginationTable
                        onPageChange={props.handlePaginationChange}
                        totalPages={totalPages}
                        activePage={activePage}
                        fields={['Section', 'Type', 'Status']}
                      >

                      </PaginationTable>
                      :
                      null
                    }
                  </Table> :
                  null
                }
              </Grid.Column>
            </Grid>
          <h3>SUBJECTS</h3>

          <ToDoModal
            title='Quarter Summary'
            quarter={quarter}
            isGrades={true}
            value={props.perQuarterSummary.summary.toDo.count}
            data={props.perQuarterSummary.summary.toDo.data}
            sectionSubjects={props.perQuarterSummary.sectionSubjects}
            handleNotify={props.handleNotify}
            openConfirm={props.openConfirm}
            openConfirmation={props.openConfirmation}
            closeConfirmation={props.closeConfirmation}
          />

          <CreatedModal
            title='Quarter Summary'
            quarter={quarter}
            isGrades={true}
            value={props.perQuarterSummary.summary.created.count}
            data={props.perQuarterSummary.summary.created.data}
            sectionSubjects={props.perQuarterSummary.sectionSubjects}
          />

          <CheckedModal
            title='Quarter Summary'
            quarter={quarter}
            isGrades={true}
            value={props.perQuarterSummary.summary.checked.count}
            data={props.perQuarterSummary.summary.checked.data}
            sectionSubjects={props.perQuarterSummary.sectionSubjects}
          />

          <ReviewedModal
            title='Quarter Summary'
            quarter={quarter}
            isGrades={true}
            value={props.perQuarterSummary.summary.reviewed.count}
            data={props.perQuarterSummary.summary.reviewed.data}
            sectionSubjects={props.perQuarterSummary.sectionSubjects}
          />

          <ApprovedModal
            title='Quarter Summary'
            quarter={quarter}
            isGrades={true}
            value={props.perQuarterSummary.summary.approved.count}
            data={props.perQuarterSummary.summary.approved.data}
            sectionSubjects={props.perQuarterSummary.sectionSubjects}
          />

          <h3>CONDUCTS</h3>
            <ToDoModal
              title='Quarter Summary'
              quarter={quarter}
              isGrades={false}
              value={props.perQuarterSummaryConducts.summary.toDo.count}
              data={props.perQuarterSummaryConducts.summary.toDo.data}
              sectionSubjects={props.perQuarterSummary.sectionSubjects}
              handleNotify={props.handleNotify}
              openConfirm={props.openConfirm}
              openConfirmation={props.openConfirmation}
              closeConfirmation={props.closeConfirmation}
            />

            <CreatedModal
              title='Quarter Summary'
              quarter={quarter}
              isGrades={false}
              value={props.perQuarterSummaryConducts.summary.created.count}
              data={props.perQuarterSummaryConducts.summary.created.data}
              sectionSubjects={props.perQuarterSummaryConducts.sectionSubjects}
            />

            <CheckedModal
              title='Quarter Summary'
              quarter={quarter}
              isGrades={false}
              value={props.perQuarterSummaryConducts.summary.checked.count}
              data={props.perQuarterSummaryConducts.summary.checked.data}
              sectionSubjects={props.perQuarterSummaryConducts.sectionSubjects}
            />

            <ReviewedModal
              title='Quarter Summary'
              quarter={quarter}
              isGrades={false}
              value={props.perQuarterSummaryConducts.summary.reviewed.count}
              data={props.perQuarterSummaryConducts.summary.reviewed.data}
              sectionSubjects={props.perQuarterSummaryConducts.sectionSubjects}
            />

            <ApprovedModal
              title='Quarter Summary'
              quarter={quarter}
              isGrades={false}
              value={props.perQuarterSummaryConducts.summary.approved.count}
              data={props.perQuarterSummaryConducts.summary.approved.data}
              sectionSubjects={props.perQuarterSummaryConducts.sectionSubjects}
            />
        </div>
      )
    } else {
      body = (
        <Loader active inline='centered' />
      )
    }

    return (
      <div>
      {
        props.loadedSubject || props.loadedClass || props.loadedLevel || props.loadedQuarter?
          <Segment textAlign='center' >
            <h3>Grading System Dashboard</h3>
            <div className='school-year-dropdown'>
              <Dropdown
                selection
                name='schoolYearId'
                options={optionsSchoolYears}
                onChange={props.handleChangeSchoolYear}
                value={props.schoolYearId}
              />
              <Dropdown
                selection
                name='quarter'
                options={optionsQuarters}
                onChange={props.handleChangeQuarter}
                value={props.quarter}
              />
            </div>
            <div>
              <Button inverted color='blue' active={props.activeButton === 'subject'} onClick={()=>props.handleClick('subject')}>
                My Subjects
              </Button>
              {
                props.userType === 'admin' || props.userType === 'adviser'?
                <Button inverted color='blue' active={props.activeButton === 'section'} onClick={()=>props.handleClick('section')}>
                  My Class
                </Button> :
                null
              }

              {
                props.userType === 'admin' || props.userType === 'levelHead'?
                <Button inverted color='blue' active={props.activeButton === 'level'} onClick={()=>props.handleClick('level')}>
                  Level Summary
                </Button> :
                null
              }


              {
                props.userType === 'admin' || props.userType === 'principal' || props.userType === 'registrar'?
                <Button inverted color='blue' active={props.activeButton === 'all'} onClick={()=>props.handleClick('all')}>
                  Quarter Summary
                </Button> :
                null
              }
              <Confirm
                size='tiny'
                open={props.openConfirm}
                onCancel={props.closeConfirmation}
                onConfirm={props.handleNotify}
              />
            </div>
            <Divider />

            {body}
          </Segment>
        :
        <Loader active inline='centered' />
      }
      </div>

    )
  } else {
    return <Redirect to='/' />
  }

}

export default HomePV;
